import ConfirmDialog from './confirm-component';

export const confirmService = ConfirmDialog.create();
